<template>
  <div>
    <div>
      <h3 class="text-h6">Invite</h3>
      <p>
        {{ $t("projects.userManagement.inviteDescription") }}
      </p>
      <div class="users">
        <div>
          <user-management-auto-complete
            :method="fetchUser"
            :label="$t('projects.userManagement.addUserLabel')"
            item-value="id"
            item-text="username"
            @select="onSelectUser"
          ></user-management-auto-complete>
        </div>
        <div class="text-h6">
          {{ $t("projects.userManagement.userListTitle") }}
        </div>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  {{ $t("projects.userManagement.emailLabel") }}
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="project.allowed_userlist.length === 0">
                <td>
                  {{ $t("projects.userManagement.empty") }}
                </td>
              </tr>
              <tr v-for="item in project.allowed_userlist" :key="item.id">
                <td>{{ user(item).username }}</td>
                <td>
                  <v-btn
                    text
                    @click="onDeleteUser(item)"
                    :disabled="itsMe(user(item))"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { fetchUser } from "@/api/craiyon";
import UserManagementAutoComplete from "@/components/projects/user-management/UserManagementAutoComplete";
import {
  ADD_USER_TO_PROJECT,
  REMOVE_USER_FROM_PROJECT
} from "@/store/modules/project";
import { FIND } from "@/store/modules/user";

export default {
  props: {
    project: { required: true }
  },
  data: () => ({
    userInvite: null
  }),
  computed: {
    ...mapState({ token: state => state.authentication.keycloak.token }),
    ...mapGetters({ user: FIND })
  },
  methods: {
    onDeleteUser(userId) {
      this.$store.dispatch(REMOVE_USER_FROM_PROJECT, { user: { id: userId } });
    },
    onSelectUser(user) {
      this.$store.dispatch(ADD_USER_TO_PROJECT, { user });
    },
    itsMe(user) {
      return this.$store.getters.tokenParsed.email === user.username;
    },
    async fetchUser() {
      return new Promise(resolve => {
        fetchUser(this.token).then(data => {
          // TODO filter for already selected users
          resolve(data.results);
        });
      });
    }
  },
  async mounted() {},
  components: {
    UserManagementAutoComplete
  }
};
</script>

<style scoped></style>
